import React,{Component}      from 'react';
import {
  Menu,
  Segment,
}                             from 'semantic-ui-react';
// import ReactHtmlParser        from 'react-html-parser';
import ContentEditable        from './ContentEditable';
import PropTypes              from 'prop-types';
import {noop}                 from 'lodash';
// BB code
import bbCode                 from '../../global/buildLang';

const items = [
  {
    key  : 'bold',
    icon : 'bold',
    text : '[b]TEXT HERE[/b]',
  },
  {
    key  : 'italic',
    icon : 'italic',
    text : '[i]TEXT HERE[/i]',
  },
  {
    key  : 'underline',
    icon : 'underline',
    text : '[u]TEXT HERE[/u]',
  },
  {
    key  : 'url',
    icon : 'linkify' ,
    text : '[url]TYPE URL HERE[/url]',
  },
  {
    key  : 'urlText',
    icon : 'linkify' ,
    name : 'with text',
    text : '[url=TYPE URL HERE]TEXT HERE[/url]',
  },
  {
    key  : 'img',
    icon : 'image',
    text : '[img]URL IMAGE HERE[/img]',
  },
  {
    key  : 'color',
    name : 'Colored Text',
    text : '[color=COLOR HERE]TEXT HERE[/color]',
  },
  {
    key  : 'quote',
    icon : 'quote left',
    text : '[quote]TEXT TO QUOTE HERE[/quote]',
  },
  {
    key  : 'center',
    icon : 'align center',
    text : '[center]TEXT HERE[/center]',
  },
  {
    key  : 'large',
    name : 'Large Text',
    text : '[large]TEXT HERE[/large]',
  },
  {
    key  : 'small',
    name : 'Small Text',
    text : '[small]TEXT HERE[/small]',
  },
];

const entities = {
  'amp'  : '&',
  'apos' : '\'',
  'lt'   : '<',
  'gt'   : '>',
  'quot' : '"',
  'nbsp' : '\xa0',
};

const entityPattern = /&([a-z]+);/ig;

const decodeHTMLEntities = (text) => {
  if (!text) {
    return text;
  }

  // A single  replace pass with a static RegExp is faster than a loop
  return text.replace (entityPattern, function(match, entity) {
    entity = entity.toLowerCase();
    if (entities.hasOwnProperty(entity)) {
      return entities[entity];
    }
    // return original string if there is no matching entity (no replace)
    return match;
  });
};

const insert = (arr, index, newItem) => [
  // part of the array before the specified index
  ...arr.slice(0, index),
  // inserted item
  newItem,
  // part of the array after the specified index
  ...arr.slice(index),
];

const propTypes = {
  code    : PropTypes.string,
  display : PropTypes.string,
  onEdit  : PropTypes.func,
};

const defaultProps = {
  code    : '',
  display : 'bb',
  onEdit  : noop,
};

class BbcodeEditor extends Component {

  constructor(props) {
    super(props);
    this.state = {
      code    : props.code,
      display : props.display,
      newText : decodeHTMLEntities(props.code),
      target  : null,
    };

    this.handleMenu = this.handleMenu.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleAddBBcode = this.handleAddBBcode.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.setRef = this.setRef.bind(this);
    this._element = null;
  }

  handleMenu(e,menu) {
    const {display} = this.state;
    if (menu.text && menu.text === 'switch') {
      const newDisplay =  display === 'bb' ? 'html' : 'bb';

      this.setState({display: newDisplay}, () => {
        this.props.onEdit(this.state.newText, newDisplay);
      });
    }
    else {
      this.handleAddBBcode(menu.text);
    }
  }

  handleEdit(e, value) {
    const finalValue = value ?
      value
      :
      this._element ?
        decodeHTMLEntities(this._element.innerHTML)
        :
        null; // Should never reach this condition

    this.setState({newText: decodeHTMLEntities(finalValue)}, () => {
      this.props.onEdit(finalValue);
    });
  }

  handleAddBBcode(item) {
    const {
      code,
      target,
    } = this.state;

    const itemSelected = items.find((it) => it.text === item);

    if (itemSelected) {
      const finalValue = itemSelected.text;
      const newValue = code ?
        code.slice(0, target.selectionEnd) + finalValue + code.slice(target.selectionEnd)
        :
        finalValue;

      this.setState({code: newValue}, () => {
        this.props.onEdit(newValue);
      });
    }
  }

  handleClick(e) {
    this.setState({target: e.target});
  }

  setRef(c) {
    this._element = c;
  }

  render() {
    const {
      code,
      display,
      newText,
    } = this.state;
    newText;

    const listItems = insert(items,items.length, {
      key  : 'accueil',
      name : 'Switch to '+ (display === 'bb' ? 'html' : 'bb'),
      text : 'switch',
    });

    return (
      <Segment attached='bottom'>
        <Menu
          fluid
          items={listItems}
          onItemClick={this.handleMenu}
          size='tiny'
        />
        {
          display === 'bb' ?
            <div
              contentEditable
              onClick={this.handleClick}
              onInput={this.handleEdit}
              ref={this.setRef}
              suppressContentEditableWarning
            >
              {code}
            </div>
            :
            <ContentEditable
              content={bbCode(code)}
              disabled={false}
              onBlur={this.handleEdit}
              onChange={this.handleEdit}
              onClick={this.handleClick}
              tagName='div'
            />
        }
      </Segment>
    );
  }

}

BbcodeEditor.propTypes = propTypes;

BbcodeEditor.defaultProps = defaultProps;

export default BbcodeEditor;



// WEBPACK FOOTER //
// ./src/molecules/BbcodeEditor/BbcodeEditor.js